import { useEffect, useState } from "react";
import { useUserPreferences } from "./useUserPreferences";

/**
 * Decides whether the first-run setup wizard should auto-open. The wizard
 * shows once for new users (no preferences row, never skipped). Once the
 * user finishes or skips, this hook resolves false and stays that way.
 */
export function useOnboardingGate() {
  const { prefs, isReady, isMissing } = useUserPreferences();
  const [shouldOpen, setShouldOpen] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    // No row yet — first time we've ever seen this user. Open.
    if (isMissing) {
      setShouldOpen(true);
      return;
    }
    // Row exists, but user explicitly skipped or already completed. Don't open.
    if (prefs?.onboarding_completed_at || prefs?.onboarding_skipped) {
      setShouldOpen(false);
      return;
    }
    setShouldOpen(true);
  }, [isReady, isMissing, prefs]);

  const dismiss = () => setShouldOpen(false);

  return { shouldOpen, dismiss, isReady };
}
